import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../../../context/language/LanguageContext';
import { navItems } from '../../../utils/navData';
import logo from '../../../assets/images/logo.png';
import './Navbar.css';

const Navbar = () => {
    const [activeSubmenu, setActiveSubmenu] = useState(null);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [isLanguageDropdownOpen, setIsLanguageDropdownOpen] = useState(false);
    const { language, toggleLanguage } = useLanguage(); // Changed this line
    const location = useLocation();

    const handleMouseEnter = (index) => {
        setActiveSubmenu(index);
    };

    const handleMouseLeave = () => {
        setActiveSubmenu(null);
    };

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
        // Optional: Prevent body scroll when menu is open
        document.body.style.overflow = !isMobileMenuOpen ? 'hidden' : 'auto';
    };

    const closeMobileMenu = () => {
        setIsMobileMenuOpen(false);
    };

    const toggleLanguageDropdown = () => {
        setIsLanguageDropdownOpen(!isLanguageDropdownOpen);
    };

    const handleLanguageSelect = (selectedLang) => {
        if (language !== selectedLang) {
            toggleLanguage(); // Changed this line
        }
        setIsLanguageDropdownOpen(false);
    };

    const getCurrentLanguageText = () => {
        return language === 'en' ? 'English' : 'မြန်မာ';
    };

    const isActive = (path, submenu = null) => {
        if (path === '/') {
            return location.pathname === path;
        }
        // For menu items with submenu, check if any submenu path matches
        if (submenu) {
            return submenu.some(subItem => location.pathname === subItem.path) || location.pathname.startsWith(path);
        }
        return location.pathname === path;
    };

    return (
        <nav className="navbar">
            <div className="nav-container">
                <div className="nav-left">
                    <Link to="/" className="nav-logo">
                        <img src={logo} alt="Logo" className="nav-logo-image" />
                    </Link>

                    {/* Desktop Menu */}
                    <div className="nav-menu">
                        {navItems[language].map((item, index) => (
                            <div
                                key={index}
                                className="nav-item"
                                onMouseEnter={() => handleMouseEnter(index)}
                                onMouseLeave={handleMouseLeave}
                            >
                                {item.submenu ? (
                                    <>
                    <span className={`nav-link ${isActive(item.path, item.submenu) ? 'active' : ''}`}>
                        {item.title}
                        <span className="material-icons dropdown-icon">
                            expand_more
                        </span>
                    </span>
                                        {activeSubmenu === index && (
                                            <div className="submenu">
                                                {item.submenu.map((subItem, subIndex) => (
                                                    <Link
                                                        key={subIndex}
                                                        to={subItem.path}
                                                        className={`submenu-item ${isActive(subItem.path) ? 'active' : ''}`}
                                                    >
                                                        {subItem.title}
                                                    </Link>
                                                ))}
                                            </div>
                                        )}
                                    </>
                                ) : (
                                    <Link
                                        to={item.path}
                                        className={`nav-link ${isActive(item.path) ? 'active' : ''}`}
                                    >
                                        {item.title}
                                    </Link>
                                )}
                            </div>
                        ))}
                    </div>
                </div>

                <div className="nav-right">
                    {/* Mobile Menu Button */}
                    <button
                        className="mobile-menu-button"
                        onClick={toggleMobileMenu}
                    >
                        <span className="material-icons">
                            {isMobileMenuOpen ? 'close' : 'menu'}
                        </span>
                    </button>

                    {/* Language Dropdown */}
                    <div className="language-dropdown-container">
                        <button onClick={toggleLanguageDropdown} className="language-toggle">
                            <span className="material-icons language-icon">
                                language
                            </span>
                            <span className="language-text">
                                {getCurrentLanguageText()}
                            </span>
                            <span className={`material-icons arrow-icon ${isLanguageDropdownOpen ? 'rotated' : ''}`}>
                                arrow_drop_down
                            </span>
                        </button>

                        {isLanguageDropdownOpen && (
                            <div className="language-dropdown">
                                <button
                                    className={`language-option ${language === 'en' ? 'active' : ''}`}
                                    onClick={() => handleLanguageSelect('en')}
                                >
            <span className="material-icons" style={{ fontSize: '18px' }}>
                {language === 'en' ? 'radio_button_checked' : 'radio_button_unchecked'}
            </span>
                                    English
                                </button>
                                <button
                                    className={`language-option ${language === 'my' ? 'active' : ''}`}
                                    onClick={() => handleLanguageSelect('my')}
                                >
            <span className="material-icons" style={{ fontSize: '18px' }}>
                {language === 'my' ? 'radio_button_checked' : 'radio_button_unchecked'}
            </span>
                                    မြန်မာ
                                </button>
                            </div>
                        )}
                    </div>

            {/* Mobile Menu */}
                    {/* Mobile Menu */}
                    <div className={`mobile-menu ${isMobileMenuOpen ? 'active' : ''}`}>
                        {navItems[language].map((item, index) => (
                            <div key={index} className="nav-item">
                                {item.submenu ? (
                                    <>
                                        <div className={`nav-link ${isActive(item.path, item.submenu) ? 'active' : ''}`}>
                                            {item.title}
                                            <span className="material-icons">expand_more</span>
                                        </div>
                                        <div className="submenu">
                                            {item.submenu.map((subItem, subIndex) => (
                                                <Link
                                                    key={subIndex}
                                                    to={subItem.path}
                                                    className={`submenu-item ${isActive(subItem.path) ? 'active' : ''}`}
                                                    onClick={closeMobileMenu}
                                                >
                                                    {subItem.title}
                                                </Link>
                                            ))}
                                        </div>
                                    </>
                                ) : (
                                    <Link
                                        to={item.path}
                                        className={`nav-link ${isActive(item.path) ? 'active' : ''}`}
                                        onClick={closeMobileMenu}
                                    >
                                        {item.title}
                                    </Link>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;